import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '漫画分类',
    links: [
      { label: '治愈漫画', path: '/category/healing' },
      { label: '科幻漫画', path: '/category/sci-fi' },
      { label: '仙侠漫画', path: '/category/xianxia' },
      { label: '悬疑漫画', path: '/category/suspense' },
    ],
  },
  {
    title: '热门推荐',
    links: [
      { label: '洞洞杂货铺', path: '/comic/dongdong-zahuopu' },
      { label: '剑仙传', path: '/comic/jian-xian-zhuan' },
      { label: '时空旅行者', path: '/comic/shikong-lvxingzhe' },
      { label: '学校怪谈', path: '/comic/xuexiao-guaitan' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系方式', path: '/about#contact' },
      { label: '用户协议', path: '/about#terms' },
      { label: '隐私政策', path: '/about#privacy' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '常见问题', path: '/about#faq' },
      { label: '阅读指南', path: '/about#guide' },
      { label: '反馈建议', path: '/about#feedback' },
      { label: '加入我们', path: '/about#join' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-200">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
                <a href={group.links[0]?.path || '#'} className="hover:text-primary-400 transition-colors">
                  {group.title}
                </a>
              </h4>
              <div className="w-8 h-px bg-primary-600/50 mb-4"></div>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <span className="text-2xl font-display font-bold text-primary-500">073漫画</span>
            <p className="text-xs text-foreground-500 mt-2">
              在线免费阅读下拉式漫画，追漫不受限制
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-all duration-200"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="#"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-all duration-200"
              aria-label="微信"
              rel="nofollow"
            >
              <i className="ri-wechat-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="#"
              className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-600 text-foreground-300 hover:text-background-50 transition-all duration-200"
              aria-label="B站"
              rel="nofollow"
            >
              <i className="ri-bilibili-line w-4 h-4 flex items-center justify-center"></i>
            </a>
          </div>
        </div>

        <div className="mt-6 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 073漫画网 版权所有
          </p>
          <p className="text-xs text-foreground-600">
            <a href="/about#terms" className="hover:text-primary-400 transition-colors">用户协议</a>
            <span className="mx-2">|</span>
            <a href="/about#privacy" className="hover:text-primary-400 transition-colors">隐私政策</a>
          </p>
        </div>
      </div>
    </footer>
  );
}